import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { BUTTONS_DEFAULT_TITLE } from 'site-modules/editorial/constants/best';
import { Link } from 'site-modules/shared/components/link/link';

const BUTTON_CLASS_NAME = 'size-16 px-0_75 px-sm-1 py-0_25 mb-1';

export function CardButtons({ primaryLink, secondaryLink, ariaId = null }) {
  if (!primaryLink.url && !secondaryLink.url) {
    return null;
  }
  const secondaryLinkId = ariaId ? `secondary-link-${ariaId}` : null;
  const primaryLinkId = ariaId ? `primary-link-${ariaId}` : null;

  return (
    <div className="card-buttons mt-1">
      {!!secondaryLink.url && (
        <Button
          className={classnames(BUTTON_CLASS_NAME, 'me-0_75')}
          color="outline-primary-b"
          tag={Link}
          to={secondaryLink.url}
          target={secondaryLink.blank ? '_blank' : null}
          rel={secondaryLink.nofollow ? 'nofollow' : null}
          data-tracking-id="mmy_select"
          id={secondaryLinkId}
          aria-labelledby={classnames(secondaryLinkId, ariaId)}
        >
          {secondaryLink.title || BUTTONS_DEFAULT_TITLE.SECONDARY}
        </Button>
      )}
      {!!primaryLink.url && (
        <Button
          className={BUTTON_CLASS_NAME}
          color="primary-b"
          tag={Link}
          to={primaryLink.url}
          target={primaryLink.blank ? '_blank' : null}
          rel={primaryLink.nofollow ? 'nofollow' : null}
          data-tracking-id="view_search_result"
          id={primaryLinkId}
          aria-labelledby={classnames(primaryLinkId, ariaId)}
        >
          {primaryLink.title || BUTTONS_DEFAULT_TITLE.PRIMARY}
        </Button>
      )}
    </div>
  );
}

CardButtons.propTypes = {
  primaryLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  secondaryLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  ariaId: PropTypes.string,
};
